import React from 'react';
import { X } from 'lucide-react';

const ConfirmationModal = ({
  isVisible,
  onConfirm,
  onCancel,
  title = 'Confirm Action',
  confirmText = 'Are you sure you want to continue?',
  confirmButtonText = 'Confirm',
  loading = false,
  actionType = 'rebuild'
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  // Button color based on action type
  const getButtonColor = () => {
    switch (actionType) {
      case 'stop':
        return 'bg-red-600 hover:bg-red-700';
      case 'start':
        return 'bg-green-600 hover:bg-green-700';
      case 'rebuild':
        return 'bg-indigo-600 hover:bg-indigo-700';
      default:
        return 'bg-indigo-600 hover:bg-indigo-700';
    }
  };

  if (!isVisible) return null;
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

      {/* Modal */}
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
          {/* Header */}
          <div className="bg-gray-900 px-4 py-3 flex justify-between items-center">
            <h3 className="text-lg font-medium text-white">
              {title}
            </h3>
            <button
              onClick={handleCancel}
              className="rounded-full p-1 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="mb-6">
              <p className="text-gray-700">{confirmText}</p>
            </div>
            
            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={handleCancel}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={loading}
                className={`px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${getButtonColor(actionType)} disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                {loading ? 'Processing...' : confirmButtonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;